import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

function AdminAttendanceReport({ token: propToken }) {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Helper to get valid admin access token, refresh if needed
  async function getAdminAccessToken() {
    let accessToken = localStorage.getItem('gogig_admin_access');
    const refreshToken = localStorage.getItem('gogig_admin_refresh');
    if (accessToken) {
      try {
        const res = await fetch(`${API_URL}/api/admin/stats`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        if (res.status !== 401) return accessToken;
      } catch {}
    }
    if (refreshToken) {
      try {
        const res = await fetch(`${API_URL}/api/admin/refresh-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refreshToken })
        });
        const data = await res.json();
        if (data.success && data.accessToken) {
          localStorage.setItem('gogig_admin_access', data.accessToken);
          return data.accessToken;
        }
      } catch {}
    }
    // Clear tokens and redirect to login instead of reloading
    localStorage.removeItem('gogig_admin_access');
    localStorage.removeItem('gogig_admin_refresh');
    window.location.href = '/admin'; // Redirect to admin login page
    return null;
  }

  async function adminFetch(url, options = {}) {
    const token = await getAdminAccessToken();
    if (!token) throw new Error('Not authenticated');
    const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` };
    return fetch(url, { ...options, headers });
  }

  const handleDownload = async () => {
    setError('');
    if (!month || !year) return setError('Select month and year');
    setLoading(true);
    try {
      const res = await adminFetch(`${API_URL}/api/attendance/report?month=${month}&year=${year}`);
      if (!res.ok) throw new Error('Download failed');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `attendance_report_${month}_${year}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError('Download failed');
    }
    setLoading(false);
  };

  return (
    <div className="gogig-card" style={{ maxWidth: 400, margin: '0 auto', padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>Attendance Report</h2>
      <div style={{ marginBottom: 10 }}>
        <label>Month: </label>
        <select
          style={{ minWidth: 80, marginRight: 10 }}
          value={month}
          onChange={e => setMonth(e.target.value)}
          tabIndex={0}
        >
          <option value="">--</option>
          {[...Array(12)].map((_, i) => (
            <option key={i+1} value={i+1}>{i+1}</option>
          ))}
        </select>
        <div style={{ fontSize: 12, color: '#888' }}>DEBUG: month state = {month}</div>
        <label style={{ marginLeft: 10 }}>Year: </label>
        <input type="number" value={year} onChange={e => setYear(e.target.value)} style={{ width: 80 }} min="2020" max={new Date().getFullYear()} />
      </div>
      {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
      <button className="gogig-card-btn" onClick={handleDownload} disabled={loading}>Download CSV</button>
    </div>
  );
}

export default AdminAttendanceReport; 